import { useTrans } from '../../../hooks'
import { InfoProgettoCollezioneObject } from '@gql/graphql'
import { ScrollRef, WContainer } from '../../atoms'
import styles from './CollezioniInfoShowcase.module.sass'

interface Props {
  refId?: string
  item: InfoProgettoCollezioneObject[]
  handleClickTracking?: (item: any, index: number) => void
  className?: string
}

const CollezioniInfoShowcase = (props: Props) => {
  const {
    item = undefined,
    refId = undefined,
    handleClickTracking = undefined,
    className = '',
  } = props

  const t = useTrans()

  const dati = [
    {
      headerLabel: t('Collezione'),
      value: (i, infoProgetto, index) => (
        <a
          href={i.collezione.url}
          onClick={() => {
            handleClickTracking(i.collezione, index)
          }}
        >
          {i.collezione.nome}
        </a>
      ),
    },
    {
      headerLabel: t('Colore e finitura'),
      value: (i, infoProgetto) =>
        infoProgetto.tonalitaUrl ? (
          <a href={infoProgetto.tonalitaUrl}>
            {[infoProgetto.coloreNome, infoProgetto.finituraNome].filter((v) => !!v).join(' ')}
          </a>
        ) : (
          [infoProgetto.coloreNome, infoProgetto.finituraNome].filter((v) => !!v).join(' ')
        ),
    },
    {
      headerLabel: t('Formato'),
      value: (i, infoProgetto, index) =>
        infoProgetto.formato.lato1Cm && infoProgetto.formato.lato2Cm
          ? `${infoProgetto.formato.lato1Cm} x ${infoProgetto.formato.lato2Cm} cm`
          : '',
    },
    {
      headerLabel: t('Superficie'),
      value: (i, infoProgetto, index) => infoProgetto.superficie.nome,
    },
    { headerLabel: t('Spessore'), value: (i, infoProgetto, index) => infoProgetto.spessore },
  ]

  return item?.length ? (
    <div className={`${styles.root} ${className} `}>
      {refId && <ScrollRef id={refId} offset={false} className={styles.ref} />}
      <WContainer>
        <div className={styles.main}>
          <h2 className={styles.title}>{t('Collezioni nel Progetto')}</h2>
          <div className={styles.content}>
            <div className={`${styles.tableRow} ${styles.tableHeader}`}>
              {dati.map((x, index) => (
                <p key={index}>{x.headerLabel}</p>
              ))}
            </div>
            {item?.length > 0 &&
              item.map((i, indx) => (
                <div className={styles.group} key={indx}>
                  {i?.infoProgetti?.length > 0 &&
                    i.infoProgetti.map((infoProgetto) => (
                      <div className={styles.tableRow} key={`${indx}_${infoProgetto.id}`}>
                        {dati.map((x, index) => (
                          <div className={styles.cardRow} key={index}>
                            <span className={styles.cardLabel}>{x.headerLabel}:</span>{' '}
                            {x.value(i, infoProgetto, index)}
                          </div>
                        ))}
                      </div>
                    ))}
                </div>
              ))}
          </div>
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default CollezioniInfoShowcase
